export default __webpack_public_path__ + "static/media/FS-ABOUT-EQUIPO-HELPDESK-ICON.9a2479e4.svg";